import { getReq } from '../service/API'
import useSWR from 'swr'
import { getProjectByIdEndpoint } from '../service/api-gateway'
//import { errorStore } from '../store/ErrorStore'

export const useProjectById = (projectId: string) => {
  const p = getProjectByIdEndpoint(projectId)

  //const cacheKey = formId ? p : null
  const { data, error } = useSWR(p, getReq, {
    suspense: true,
    dedupingInterval: 60 * 60 * 1000, // 60 minutes in milliseconds
    revalidateOnReconnect: false,
    revalidateOnFocus: false,
  })

  /*if (error) {
		setError(error.error)
	}*/

  return {
    data: !data ? data : data.data,
    isLoading: !error && !data,
    isError: error,
  }
}
